import { render, staticRenderFns } from "./BarChartMonth.vue?vue&type=template&id=8415851a&"
import script from "./BarChartMonth.vue?vue&type=script&lang=js&"
export * from "./BarChartMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports